import axios from 'axios';

import Config from '@Config';

import TokenService from './token.service';

const BASE_URL = Config.REACT_APP_BASE_API_URL || '';

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${TokenService.getAccessToken() || ''}`,
  },
});

export default axiosInstance;
